/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Errors_Logingenericerror2Inputs */

const en_errors_logingenericerror2 = /** @type {(inputs: Errors_Logingenericerror2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in failed, please try again. If issue persists`)
};

/**
* | output |
* | --- |
* | "Sign in failed, please try again. If issue persists" |
*
* @param {Errors_Logingenericerror2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const errors_logingenericerror2 = /** @type {((inputs?: Errors_Logingenericerror2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Errors_Logingenericerror2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_errors_logingenericerror2(inputs)
});
export { errors_logingenericerror2 as "errors_loginGenericError" }